import axios from 'axios';
import { useQuery } from 'react-query';

import { ICalculatedAttribute } from 'features/seismic/models/interfaces/ICalculatedAttribute';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { useSessionStore } from 'session/useSessionStore';

export const useAllCalculatedAttributes = () => {
    const jwt = useSessionStore(state => state.jwtToken);
    const host = useSessionStore(state => state.tenantConfiguration?.endpoints.calculatedAttributes);

    return useQuery(['allCalculatedAttributes'], async () => {
        const response = await axios.get<IResponseAPI<ICalculatedAttribute[]>>(host + '/Seismic/CalculatedAttribute/All', { headers: { Authorization: 'Bearer ' + jwt } });
        return response.data.Result;
    });
};